import data from './data';

export default {
  mixins: [data],
  mounted: function mounted() {
    this.getCurrentApprovalTrack();
  },

  methods: {
    getFormField: function getFormField() {
      var _this = this;

      if (this.formId) {
        this.$store.dispatch('postRequest', {
          url: '/bsp-com/com/form/getFormFieldByFormId',
          params: {
            formId: this.formId
          }
        }).then(function (resp) {
          if (resp.success) {
            if (resp.data && resp.data.length > 0) {
              resp.data.forEach(function (item) {
                if (item.isMain == '1') {
                  _this.formArr = item.children;
                  var obj = {};
                  var keyName = '';
                  _this.formArr.forEach(function (ele) {
                    if (ele.isProcessVar && ele.isProcessVar == '1') {
                      keyName = ele.fieldName;
                      obj[keyName] = _this.formDataVarObj[ele.fieldName];
                    }
                  });
                  _this.ProcessVarObj = obj;
                }
              });
              _this.getAduitApprovalUser();
            } else {
              _this.getAduitApprovalUser();
            }
          }
        });
      }
    },
    getForm: function getForm() {
      var _this2 = this;

      var params = {
        operType: this.operType,
        formId: this.formId,
        businessId: this.businessId
      };
      this.$store.dispatch('postRequest', {
        url: '/bsp-com/com/form/handle/getFormData',
        params: params
      }).then(function (resp) {
        if (resp.success) {
          // console.log(resp,resp.success,'resp.data')
          _this2.formDataVarObj = resp.formData;
          _this2.getFormField();
        } else {
          _this2.warnSwal('文书模版加载出错。原因:' + resp.msg);
        }
      });
    },
    initData: function initData() {
      if (this.businessId === '') {
        this.warnSwal('未设置业务编号[businessId]。');
        return;
      }
      if (this.module === '') {
        this.warnSwal('未设置模块名称[module]。');
      }
    },

    // 获取当前审批节点
    getCurrentApprovalTrack: function getCurrentApprovalTrack() {
      var _this3 = this;

      if (!this.actInstId) {
        this.warnSwal('流程实例ID不能为空');
        return;
      }
      this.$store.dispatch('postRequest', {
        url: 'bsp-bpm/bpm/approveProcess/currentApprovalTrack',
        params: {
          actInstId: this.actInstId
        }
      }).then(function (resp) {
        if (resp.success) {
          _this3.hasApproveAuth = true;
          _this3.showSp = true;
          _this3.$nextTick(function () {
            if (this.bindEvent && this.$slots.func) {
              this.reference = this.$slots.func[0].elm;
              if (this.reference) {
                this.reference.addEventListener('click', this.openAudit);
              }
            }
          });

          _this3.currentNodeName = resp.currentNodeName;
          _this3.isLastUserTask = resp.isLastUserTask;
          _this3.formValidate.taskId = resp.taskId;
          _this3.showTc = resp.firstNodeShowTc;
          _this3.initBtn(resp.buttons);
          _this3.formId ? _this3.getForm() : _this3.getAduitApprovalUser();
          if (resp.isLastUserTask || resp.delegationState == 'PENDING') {
            _this3.showApproveUser = false;
          }
          _this3.delegationState = resp.delegationState;
          _this3.currentNodeId = resp.currentNodeId ? resp.currentNodeId : '';

          _this3.getButtonByInstIdAndNodeId(_this3.actInstId, resp.currentNodeId);

          _this3.rollbackNodeList = resp.rollbackNodeList;
          if (_this3.rollbackNodeList && _this3.rollbackNodeList.length > 0) {
            _this3.formValidate.backNodeId = _this3.rollbackNodeList[0]['id'];
          }

          // 组装当前任务节点信息
          _this3.currTask.currentNodeName = resp.currentNodeName;
          _this3.currTask.taskId = resp.taskId;
          _this3.currTask.isLastUserTask = resp.isLastUserTask;
          _this3.currTask.firstNodeShowTc = resp.firstNodeShowTc;
          _this3.currTask.delegationState = resp.delegationState;
          _this3.currTask.currentNodeId = resp.currentNodeId;
          _this3.currTask.isFirstNode = resp.isFirstNode;
          _this3.currTask.buttons = resp.buttons;
          _this3.currTask.rollbackNodeList = resp.rollbackNodeList;
          _this3.currTask.curentTaskApproveUser = resp.curentTaskApproveUser;

          // 判断当前节点是否为法制审核节点
          // this.justFzshCurNode()
        } else {
          _this3.hasApproveAuth = false;
          _this3.showSp = false;
          _this3.tabValue = 'flow';
        }
        _this3.$emit('init', _this3.hasApproveAuth);
      });
    },

    // 判断当前节点是否为法制审核节点
    justFzshCurNode: function justFzshCurNode() {
      var _this4 = this;

      this.postRequest({
        url: 'bsp-bpm/bpm/nodeSetting/isFzsh',
        params: {
          actInstId: this.actInstId,
          nodeId: this.currentNodeId
        }
      }).then(function (resp) {
        if (resp.success) {
          // 是否需要法制审核
          _this4.curNodeSffzsh = resp.sffzsh;
        }
      });
    },

    // 判断所选择的节点是否需要法制审核
    justFzshNextNode: function justFzshNextNode() {
      var _this5 = this;

      if (this.selectNode) {
        this.postRequest({
          url: 'bsp-bpm/bpm/nodeSetting/isFzsh',
          params: {
            actInstId: this.actInstId,
            nodeId: this.selectNode
          }
        }).then(function (resp) {
          if (resp.success) {
            // 是否需要法制审核
            _this5.selectNodeSffzsh = resp.sffzsh;
            if (_this5.selectNodeSffzsh) {
              // 审核结果修改
              _this5.optionsBtnArr.forEach(function (item) {
                if (item.code == 1) item.name = '流转法制';
              });
            } else {
              _this5.optionsBtnArr.forEach(function (item) {
                if (item.code == 1) item.name = _this5.curAgreeButtonName;
              });
            }
          }
        });
      }
    },
    initBtn: function initBtn(data) {
      var _this6 = this;

      this.customBtnArr = [];
      this.optionsBtnArr = [];

      if (data && data.length < 1) return;

      // 默认先初始化按钮
      // this.formValidate.isApprove = data[0].code
      // this.formValidate.isApproveStr = data[0].name
      // this.formValidate.approvalContent = data[0].defaultOption

      data.map(function (item) {
        if (item.type == '1') {
          _this6.customBtnArr.push(item);
        } else {
          _this6.optionsBtnArr.push(item);
        }
      });

      this.isApproveChange(data[0].code);

      this.optionsBtnArr.forEach(function (item) {
        if (item.code == 1) _this6.curAgreeButtonName = item.name;
      });
    },
    onSelectNode: function onSelectNode(nodeId) {
      var _this7 = this;

      this.nextNodeList.forEach(function (item) {
        if (item.nodeId == nodeId) {
          _this7.orgArr = item.orgUser;
        }
      });
      // 清空单位值，清空复选框
      /* this.orgUserList = []
          this.selectOrgArr = [] */
      // 默认选中第一项
      if (this.orgArr && this.orgArr.length > 0) {
        this.orgSelectEvent({
          label: this.orgArr[0].orgName,
          value: this.orgArr[0].orgId
        });
        this.selectOrgArr = [];
        this.selectOrgArr.push(this.orgArr[0].orgId);
      }

      // 判断所选择的节点是否需要法制审核
      // this.justFzshNextNode()
    },
    checkAllGroupChange: function checkAllGroupChange(data) {
      var count = 0;
      this.orgUserList.forEach(function (item) {
        item.user.forEach(function (item) {
          count++;
        });
      });
      if (data.length === count) {
        this.indeterminate = false;
        this.checkAll = true;
      } else if (data.length > 0) {
        this.indeterminate = true;
        this.checkAll = false;
      } else {
        this.indeterminate = false;
        this.checkAll = false;
      }
    },
    handleCheckAll: function handleCheckAll() {
      var _this8 = this;

      if (this.indeterminate) {
        this.checkAll = false;
      } else {
        this.checkAll = !this.checkAll;
      }
      this.indeterminate = false;
      if (this.checkAll) {
        this.orgUserList.forEach(function (item) {
          item.user.forEach(function (item) {
            _this8.checkedUser.push(item.userIdCard + '_' + item.orgCode);
          });
        });
      } else {
        this.checkedUser = [];
      }
    },
    getAduitApprovalUser: function getAduitApprovalUser() {
      var _this9 = this;

      var formProcessVar = '';
      this.formId ? formProcessVar = JSON.stringify(this.ProcessVarObj) : '';

      this.$store.dispatch('postRequest', {
        url: 'bsp-bpm/bpm/approveProcess/getApproveUser',
        params: {
          actInstId: this.actInstId,
          userId: this.assigneeUserId,
          extraOrgId: this.extraOrgId,
          extraRegId: this.extraRegId,
          extraCityId: this.extraCityId,
          formProcessVar: formProcessVar
        }
      }).then(function (resp) {
        if (resp.success) {
          var _data = resp.data;
          var nodeData = _data && _data.length > 0 ? _data[0] : {};
          // 如果下一节点是排它网关
          if (nodeData && nodeData.nodeType && nodeData.nodeType == 'exclusiveGateway') {
            _this9.nextNodeList = nodeData.orgUserList;
            // 默认选中第一个节点
            // this.selectNode = this.nextNodeList[0].nodeId
            // this.orgArr = this.nextNodeList[0].orgUser
            // 判断所选择的节点是否需要法制审核
            // this.justFzshNextNode()
            return;
          }
          // 当下一节点不是排它网关时
          _this9.selectNode = nodeData.nodeId;
          // 判断下一节点是否需要法制审核
          // this.justFzshNextNode()
          // 获取机构用户列表
          var orgUserList = nodeData.orgUserList;
          _this9.orgArr = orgUserList;
          // 默认选中第一项
          if (orgUserList && orgUserList.length > 0) {
            var selectOrg = _this9.getSelectOrg(orgUserList, _this9.extraOrgId, _this9.extraRegId);
            console.log(selectOrg, 'selectOrg');
            _this9.orgSelectEvent({
              label: selectOrg.orgName,
              value: selectOrg.orgId
            }, true);
            _this9.selectOrgArr.push(selectOrg.orgId);
          }
        }
      });
    },
    getSelectOrg: function getSelectOrg(orgUserList, extraOrgId, extraRegId) {
      var extraOrgIdArr = extraOrgId ? extraOrgId.split(',') : [];
      var extraRegionIdArr = extraRegId ? extraRegId.split(',') : [];
      // 先根据机构id匹配
      for (var i in extraOrgIdArr) {
        var matchOrgIdVal = extraOrgIdArr[i];
        for (var j in orgUserList) {
          var item = orgUserList[j];
          if (matchOrgIdVal === item['orgId']) {
            return item;
          }
        }
      }
      // 根据机构id没有匹配到时再根据区域id匹配
      for (var _i in extraRegionIdArr) {
        var matchRegionId = extraRegionIdArr[_i];
        for (var _j in orgUserList) {
          var _item = orgUserList[_j];
          if (matchRegionId === _item['regId']) {
            return _item;
          }
        }
      }
      // 都没匹配到就默认第一个
      return orgUserList[0];
    },
    orgSelectEvent: function orgSelectEvent(option, selectTag) {
      var _this10 = this;

      // 默认全选
      this.indeterminate = false;
      this.checkAll = true;
      var index = this.orgArr.findIndex(function (item) {
        return item.orgId == option.value;
      });
      this.orgUserList = [];
      this.checkedUser = [];
      this.orgUserList.push(this.orgArr[index]);
      if (this.selectUsers && selectTag) {
        var selectUsersArr = this.selectUsers.split(',');
        this.orgArr[index].user.map(function (item) {
          return selectUsersArr.forEach(function (ele) {
            if (item.userIdCard == ele) {
              _this10.checkedUser.push(item.userIdCard + '_' + item.orgCode);
            }
          });
        });
        // 如果默认人员不存在 设置全选
        if (this.checkedUser && this.candidateUsers && this.candidateUsers.length == 0) {
          this.orgArr[index].user.map(function (item) {
            return _this10.checkedUser.push(item.userIdCard + '_' + item.orgCode);
          });
        }
        if (this.checkedUser.length == this.orgArr[index].user.length) {
          this.indeterminate = false;
          this.checkAll = true;
        } else {
          this.indeterminate = true;
          this.checkAll = false;
        }
      } else {
        this.orgArr[index].user.map(function (item) {
          return _this10.checkedUser.push(item.userIdCard + '_' + item.orgCode);
        });
      }

      // // 判断当前项是选中还是取消选中
      // let selectIndex = this.selectOrgArr.findIndex(
      //   (item) => option.value == item
      // );
      //
      // // 获取当前选中的机构对应用户
      // let index = this.orgArr.findIndex((item) => {
      //   return item.orgId == option.value;
      // });
      //
      // if (selectIndex > -1) {
      //   // 取消选中
      //   this.orgArr[index].user.map((item) => {
      //     let userIndex = this.checkedUser.findIndex(
      //       (userIdCard) => userIdCard == item.userIdCard
      //     );
      //     if (userIndex > -1) this.checkedUser.splice(userIndex, 1);
      //   });
      //
      //   // 获取当前选中的机构对应用户
      //   let orgUserIndex = this.orgUserList.findIndex((item) => {
      //     return item.orgId == option.value;
      //   });
      //
      //   this.orgUserList.splice(orgUserIndex, 1);
      // } else {
      //   // 选中
      //   this.orgUserList.push(this.orgArr[index]);
      //   this.orgArr[index].user.map((item) =>
      //     this.checkedUser.push(item.userIdCard)
      //   );
      // }
    },
    handleSubmit: function handleSubmit(name) {
      var _this11 = this;

      if (this.formValidate.isApprove == 4) {
        this.ruleValidate.delegateUserName[0].required = true;
      } else if (this.formValidate.isApprove == 5) {
        this.ruleValidate.approveCheckedUser[0].required = false;
        this.ruleValidate.delegateUserName[0].required = false;
      } else if (this.formValidate.isApprove == 1 && !this.isLastUserTask) {
        if (this.checkedUser.length < 1) {
          this.$Notice.error({
            title: '错误提示',
            desc: '请选择审批人'
          });
          return;
        }
        this.ruleValidate.delegateUserName[0].required = false;
      } else {
        this.ruleValidate.delegateUserName[0].required = false;
      }

      this.$refs[name].validate(function (valid) {
        if (valid) {
          if (!_this11.customizeValidate()) return;
          _this11.custom_loading = true;
          if (_this11.beforeAudit) {
            _this11.beforeAudit({
              'formData': _this11.formValidate,
              'currTask': _this11.currTask
            }).then(function (data) {
              if (data) {
                _this11.approval();
              } else {
                _this11.custom_loading = false;
              }
            }).catch(function (err) {
              _this11.custom_loading = false;
              _this11.$Notice.error({
                title: '错误提示',
                desc: err
              });
            });
          } else {
            _this11.approval();
          }
        } else {
          _this11.$Notice.error({
            title: '错误提示',
            desc: '表单验证不通过'
          });
        }
      });
    },
    approval: function approval() {
      var _this12 = this;

      this.custom_loading = true;
      this.assembleData();
      this.$store.dispatch('postRequest', {
        url: 'bsp-bpm/bpm/approveProcess/approvalProcess',
        params: {
          processCmd: JSON.stringify(this.bootData)
        }
      }).then(function (resp) {
        _this12.custom_loading = false;
        if (resp.success) {
          _this12.disabledSubmit = true;
          if (_this12.auditComplete) {
            _this12.auditComplete(resp);
          } else {
            // 隐藏审批按钮
            _this12.hasApproveAuth = false;
            _this12.$Modal.success({
              title: '温馨提示',
              content: '审批成功'
            });
          }
          _this12.$emit('audit-close');
        } else {
          if (_this12.error) {
            _this12.error(resp);
          } else {
            _this12.$Modal.error({
              title: '温馨提示',
              content: '审批失败，请重试'
            });
          }
        }
      });
    },

    // 组装请求参数
    assembleData: function assembleData() {
      this.bootData = {
        actInstId: this.actInstId,
        assigneeUserId: this.assigneeUserId,
        assigneeUserName: this.assigneeUserName,
        assigneeOrgId: this.assigneeOrgId,
        assigneeOrgName: this.assigneeOrgName,
        businessId: this.businessId,
        fApp: this.module,
        fXxpt: this.platform,
        isTerminateTask: this.isTerminateTask,
        variables: this.variables,
        msgUrl: this.msgUrl,
        msgTit: this.msgTit
      };

      this.formValidate.candidateUsers = this.convertCandidateUsers();
      Object.assign(this.bootData, this.formValidate, {
        csldbh: this.convertCsldbh()
      }, {
        delegateUser: this.convertDelegate()
      });
      this.bootData.variables.nextNodeId = this.selectNode;
    },
    convertDelegate: function convertDelegate() {
      return {
        idCard: this.delegateUser.idCard,
        orgCode: this.delegateUser.orgCode
      };
    },
    convertCsldbh: function convertCsldbh() {
      return this.csldList.map(function (item) {
        return {
          idCard: item.idCard,
          orgCode: item.orgCode
        };
      });
    },
    convertCandidateUsers: function convertCandidateUsers() {
      return this.checkedUser.map(function (item) {
        var array = item.split('_');
        return {
          idCard: array[0],
          orgCode: array[1]
        };
      });
    },

    // 自定义验证
    customizeValidate: function customizeValidate() {
      var validate = true;

      // 退查或不同意时不做验证
      if (!this.showApproveUser) {
        return validate;
      }

      if (!this.selectNode) {
        this.$Modal.warning({
          title: '错误提示',
          content: '审核节点不能为空'
        });
        validate = false;
      } else if (this.selectOrgArr.length <= 0) {
        this.$Modal.warning({
          title: '错误提示',
          desc: '审核部门不能为空'
        });
        validate = false;
      } else if (this.checkedUser.length <= 0) {
        this.$Notice.error({
          title: '错误提示',
          desc: '审核人不能为空'
        });
        validate = false;
      }
      return validate;
    },

    dateFormat: function dateFormat(date) {
      // var date = new Date(time)
      var year = date.getFullYear();
      /* 在日期格式中，月份是从0开始的，因此要加0使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05 */
      var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
      var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
      var minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
      var seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
      // 拼接
      return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
    },
    // 重置表单
    handleReset: function handleReset(name) {
      this.$refs[name].resetFields();
      // 重新生成时间
      this.formValidate.approvalDate = this.dateFormat(new Date());
      // 清空机构选择
      this.selectOrgArr = [];
      // 清空人员选择
      this.checkedUser = [];
      // 清空人员机构选择
      this.orgUserList = [];

      this.defaultEvent();

      this.showApproveUser = true;

      this.formValidate.isDelegateTask = false;
    },

    // 审批意见改变事件时
    isApproveChange: function isApproveChange(value) {
      this.formValidate.isApprove = value;
      this.$emit('changeApproveVal', value);
      var curBtnArr = this.optionsBtnArr.filter(function (item) {
        return item.code == value;
      });

      this.formValidate.isApproveStr = curBtnArr[0].name;
      this.formValidate.approvalContent = curBtnArr[0].defaultOption;

      switch (value) {
        case '1':
          this.formValidate.isBack = false;
          this.formValidate.isDelegateTask = false;
          this.formValidate.isTerminateTask = false;
          if (this.delegationState == 'PENDING' || this.isLastUserTask) {
            this.showApproveUser = false;
          } else {
            this.showApproveUser = true;
          }
          this.defaultEvent();
          break;
        case '2':
          this.formValidate.isBack = false;
          this.formValidate.isDelegateTask = false;
          this.formValidate.isTerminateTask = false;
          this.showApproveUser = false;
          this.defaultEvent();
          break;
        case '3':
          this.formValidate.isBack = true;
          this.formValidate.isDelegateTask = false;
          this.formValidate.isTerminateTask = false;
          this.showApproveUser = false;
          this.defaultEvent();
          break;
        case '4':
          this.formValidate.isBack = false;
          this.formValidate.isDelegateTask = true;
          this.formValidate.isTerminateTask = false;
          this.showApproveUser = false;
          this.delegateEvent();
          break;
        case '5':
          // 同意并结束流程
          this.formValidate.isBack = false;
          this.formValidate.isDelegateTask = false;
          this.formValidate.isTerminateTask = true;
          if (this.delegationState == 'PENDING' || this.isLastUserTask) {
            this.showApproveUser = false;
          } else {
            this.showApproveUser = false;
          }
          this.defaultEvent();
          break;
        case '6':
          // 不同意并结束流程
          this.formValidate.isBack = false;
          this.formValidate.isDelegateTask = false;
          this.formValidate.isTerminateTask = true;
          this.showApproveUser = false;
          this.defaultEvent();
          break;
      }
    },
    getButtonByInstIdAndNodeId: function getButtonByInstIdAndNodeId(actInstId, nodeId) {
      var _this13 = this;

      this.$store.dispatch('postRequest', {
        url: 'bsp-bpm/bpm/nodeButton/getNodeButtonByParams',
        params: {
          actInstId: actInstId,
          nodeId: nodeId
        }
      }).then(function (resp) {
        if (resp.success) {
          if (resp.data) {
            resp.data.map(function (item) {
              _this13.curNodeBtnMarkArr.push(item.mark);
            });
          }
        }
      });
    },

    // 委派事件
    delegateEvent: function delegateEvent() {
      this.formLabel.approvalContent = '指派意见';
      this.formLabel.approvalDate = '指派时间';
    },
    defaultEvent: function defaultEvent() {
      this.formLabel.approvalContent = '审批意见';
      this.formLabel.approvalDate = '审批时间';
    },
    openUserSelect: function openUserSelect() {
      this.showSelectModal = true;
      this.component = 'userSelect';
    },
    selectCallBack: function selectCallBack(data) {
      this.formValidate.delegateUserId = data[0].idCard;
      this.formValidate.delegateUserName = data[0].name;
    },
    cancelCallBack: function cancelCallBack() {
      this.showSelectModal = false;
      this.component = null;
    },
    selectDelegate: function selectDelegate(data) {
      this.delegateUser = data[0];
    },
    clearDelegate: function clearDelegate() {
      this.delegateUser = {};
    },

    // 删除抄送人
    csld_close: function csld_close(idx) {
      this.csldList.splice(idx, 1);
    },

    // 选择抄送人回调
    policeConfirm: function policeConfirm(policeList) {
      var _this14 = this;

      this.csldList = policeList;

      this.formValidate.csldbh = '';
      policeList.map(function (item, index) {
        if (index != 0) {
          _this14.formValidate.csldbh += ',';
        }
        _this14.formValidate.csldbh += item.idCard;
      });
    },

    // 对话框取消事件
    cancel: function cancel() {
      this.$emit('cancel');
    },

    // 打开审核审批
    openAudit: function openAudit() {
      var _this15 = this;

      if (this.beforeOpen) {
        this.beforeOpen().then(function (data) {
          if (data) {
            _this15.initData();
            _this15.isOpen = true;
          }
        });
      } else {
        this.initData();
        this.isOpen = true;
      }
    },
    warnSwal: function warnSwal(msg, callback) {
      this.$Modal.warning({
        title: '温馨提示',
        content: msg
      });
    }
  },
  watch: {
    hasApproveAuth: function hasApproveAuth(val) {
      this.$emit('hasApproveAuth', val);
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/component/general-approve/mixins/audit-methods.js
// module id = 10
// module chunks = 0